document.addEventListener('DOMContentLoaded', function () {
  const accordions = document.querySelectorAll('.accordion');
  if (!accordions.length) return;

  accordions.forEach((accordion) => {
    const openFirst = accordion.dataset.openFirst === 'true';
    const headers = accordion.querySelectorAll('.accordion-header');

    headers.forEach((header, index) => {
      const content = header.nextElementSibling;
      if (!content) return;

      // Initial closed state
      content.style.maxHeight = '0px';
      content.style.overflow = 'hidden';

      // Open first item — force reflow so transition fires correctly
      if (openFirst && index === 0) {
        header.classList.add('active');
        content.classList.add('show');
        content.getBoundingClientRect(); // force reflow
        content.style.maxHeight = content.scrollHeight + 'px';
      }

      header.addEventListener('click', () => {
        const isOpen = content.classList.contains('show');

        // CLOSE ALL open items
        accordion.querySelectorAll('.accordion-content.show').forEach((el) => {
          // Lock current height explicitly
          el.style.maxHeight = el.scrollHeight + 'px';
          // ✅ Force reflow so browser commits the value above BEFORE animating
          el.getBoundingClientRect();
          // Now animate to 0
          el.style.maxHeight = '0px';

          el.addEventListener('transitionend', function handler() {
            el.classList.remove('show');
            el.removeEventListener('transitionend', handler);
          });

          if (el.previousElementSibling) {
            el.previousElementSibling.classList.remove('active');
          }
        });

        // OPEN CLICKED ITEM
        if (!isOpen) {
          header.classList.add('active');
          content.classList.add('show');
          content.style.maxHeight = '0px';
          // ✅ Force reflow so browser commits 0px BEFORE animating to full height
          content.getBoundingClientRect();
          content.style.maxHeight = content.scrollHeight + 'px';
        }
      });
    });

    // Resize fix
    window.addEventListener('resize', () => {
      accordion.querySelectorAll('.accordion-content.show').forEach((content) => {
        content.style.maxHeight = content.scrollHeight + 'px';
      });
    });
  });
});